export function closeActiveMenus() {
    $(".menu-active").each(function () {
        if ($(this).data("menu-destroy") === 'y') {
            $(this).remove();
        } else {
            $(this).removeClass('menu-active');
        }
    });
}

export function openMenu(target_menu_id) {
    //Close Existing Opened Menus
    closeActiveMenus();

    //Open Clicked Menu
    const el_target_menu = $(`#${target_menu_id}`);

    el_target_menu.addClass('menu-active');
    $(".menu-hider").addClass('menu-active');

    // check an apply effects
    const menu_height = el_target_menu.data("menu-height") || false,
        auto_hide_timeout = el_target_menu.data('menu-hide');

    if (auto_hide_timeout) {
        setTimeout(function () {
            el_target_menu.removeClass('menu-active');
            $(".menu-hider").removeClass('menu-active');
        }, auto_hide_timeout);
    }

    $(".btn-close,.btn-dismiss", el_target_menu).off("click").on("click", function (event) {
        event.preventDefault();

        el_target_menu.removeClass('menu-active');
        $(".menu-hider").removeClass('menu-active');
    });

    // if a height is given, use that height
    if (menu_height !== false) {
        el_target_menu.height(menu_height);
    }

    /**
     * !!! Commented out because we don't need the complexity of pushing page content out when menu is opened
     */
    /*const el_wrappers = $('.header, #footer-bar, .page-content'),
        menu_effect = el_target_menu.data("menu-effect"),
        is_menu_left = el_target_menu.hasClass('menu-box-left'),
        is_menu_right = el_target_menu.hasClass('menu-box-right'),
        is_menu_top = el_target_menu.hasClass('menu-box-top'),
        is_menu_bottom = el_target_menu.hasClass('menu-box-bottom');

    switch (menu_effect) {
        case 'menu-push':
            if (is_menu_left || is_menu_right) {
                const menu_width = el_target_menu.data("menu-width"),
                    translate_x = is_menu_left ? menu_width : menu_width * -1;

                el_wrappers.css({
                    transform: `translateX(${translate_x}px)`
                });
            } else if (is_menu_top || is_menu_bottom) {
                const menu_height = el_target_menu.data("menu-height") || el_target_menu.outerHeight(),
                    translate_y = is_menu_top ? menu_height : menu_height * -1;

                el_wrappers.css({
                    transform: `translateY(${translate_y}px)`
                });
            }
            break;

        case 'menu-parallax':
            if (is_menu_left || is_menu_right) {
                const menu_width = el_target_menu.data("menu-width"),
                    translate_x = is_menu_left ? menu_width : menu_width * -1;

                el_wrappers.css({
                    transform: `translateX(${translate_x / 10}px)`
                });
            } else if (is_menu_top || is_menu_bottom) {
                const menu_height = el_target_menu.outerHeight(),
                    translate_y = is_menu_top ? menu_height : menu_height * -1;

                el_wrappers.css({
                    transform: `translateY(${translate_y / 5}px)`
                });
            }
            break;
    }*/
}
